import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export type GtmDataLayerEvent = Record<string, unknown> & {
  event?: string;
};

@Injectable({ providedIn: 'root' })
export class GtmService {
  private initialized = false;

  init(): void {
    const containerId = environment.gtmContainerId;
    if (!containerId || this.initialized || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    if (document.getElementById('gtm-js')) {
      this.initialized = true;
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = 'gtm-js';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);

    this.initialized = true;
  }

  push(payload: GtmDataLayerEvent): void {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch {
      // GTM must never break product flows
    }
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

declare global {
  interface Window {
    dataLayer: GtmDataLayerEvent[];
  }
}
